<template>
    <div
        :class="[{'has-error': !!error},formGroupClass]"
    >
        <label v-show="label" :for="name">{{ label }} <span v-show="requireField" class="red">*</span></label>
        <flat-pickr
            v-model="date"
            :config="config"                                                          
            class="form-control" 
            placeholder="Select date"               
            name="date"
            @input="$emit('input', date)"
            @blur="$emit('validate',name,prefix)"
            @keyup="$emit('validate',name,prefix)"
            :disabled="disabled"
        >
        </flat-pickr>
        <small class="error-message" v-show="!!error">{{ error }}</small>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default {
    name: "FormMonth",
    components: {
        flatPickr
    },
    data () {
        return {
            // Initial value can be a date object as well
            date: this.value,
            // Get more form https://flatpickr.js.org/options/
            config: {
                plugins: [
                    new monthSelectPlugin({
                        shorthand: true,
                        altFormat: 'm-Y',
                        dateFormat: "Y-m",
                    })
                ]
            },                
        }
    },
    props: {
        error: { required: true },
        formGroupClass: {
            type: String,
        },
        inputClass: {
            type: String,
        },
        type: {
            type: String,
            default: "text",
        },
        value: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
        },
        requireField: {
            type: Boolean,
            default: false,
        },
        optionDatas: {
            type: Array
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        prefix: {
            type: String,
            default: "",
        },
        limitNotOverNow: {
            type: Boolean,
            default: false,
        },
        minDate: {
            type: String
        },
        maxDate: {
            type: String
        }
    },
    created() {
        console.log('Created', this.limitNotOverNow)
        if (this.limitNotOverNow) {
            this.config.enable = [{
                from: "2023-01-01",
                to: this.$dayjs().format('YYYY-MM-DD')
            }];
        }
        else if (this.minDate && this.maxDate) {
            this.config.enable = [{
                from: this.minDate,
                to: this.maxDate
            }];
        }
        else if (this.minDate) {
            this.config.enable = [{
                from: this.minDate,
                to: '2100-12-31'
            }];
        }
        else if (this.maxDate) {
            this.config.enable = [{
                from: "2023-01-01",
                to: this.maxDate
            }];
        }        
        else {
            this.config.enable = [{
                from: "1900-01-01",
                to: "2099-12-31"
            }];
        }
    },
    watch: {
        value: function () {
            this.date= this.value
        }
    },
    methods: {
        dateToFormat(value){
            return this.$dayjs(value).format('DD/MM/YYYY');
        },
        formatToDate(value){
            return this.$dayjs(value,'DD/MM/YYYY').format('YYYY-MM-DD');
        },
        checkFunction(){
            console.log('test',this.date)
        }
    },
};
</script>